/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import loadable from 'utils/loadable';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import * as PropTypes from 'prop-types';

function ComponentLoadable(props)
{
    const LazyLoad = loadable(() => import('.'), { fallback: props.fallback ?? <LoadingSpinner loading /> });
    return <LazyLoad {...props} />;
}

ComponentLoadable.propTypes = {
    fallback: PropTypes.node,
    hideColumns: PropTypes.array,
    limit: PropTypes.number,
    orderBy: PropTypes.string,
    orderMethod: PropTypes.oneOf(['asc', 'desc']),
    children: PropTypes.node,
    checkinAfter: PropTypes.instanceOf(Date),
    checkinBefore: PropTypes.instanceOf(Date),
    bookingDateAfter: PropTypes.instanceOf(Date),
    bookingHotel: PropTypes.number,
    searchFilter: PropTypes.string,
    status: PropTypes.array,
    hidePagination: PropTypes.bool,
    closedDate: PropTypes.shape({
        min: PropTypes.string,
        max: PropTypes.string,
    }),
    fixedSize: PropTypes.bool,
    report: PropTypes.string,
    getReservations: PropTypes.func,
    memberReportSelector: PropTypes.shape({
        id: PropTypes.string,
        reservations: PropTypes.array,
    }),
    getReportReservations: PropTypes.func,
};

export default ComponentLoadable;
